import React, { useEffect, useRef, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function TestimonialsCarousel() {
  const sliderRef = useRef(null);

  // Memoize testimonials to prevent array recreation on every render
  const testimonials = useMemo(() => [
    {
      id: 1,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 2,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 3,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 4,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 5,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 6,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 7,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 8,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    },
    {
      id: 9,
      name: "Ram Bahadur Dhakal",
      designation: "Project Manager",
      feedback: "Partnering with Solid Future was a game-changer for our team.",
      rating: 5,
      image: "/images/69cb57f2a5d3a.jpg"
    }
  ], []); // Empty dependency array - testimonials never change

  useEffect(() => {
    console.log("[TestimonialsCarousel] Component mounted, testimonials count:", testimonials.length);
    
    // Add small delay to ensure Slick is fully initialized
    const timer = setTimeout(() => {
      if (sliderRef.current) {
        console.log("[TestimonialsCarousel] Slider ref available:", sliderRef.current);
        console.log("[TestimonialsCarousel] Slider initialized and ready");
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [testimonials]);

  const handlePrevClick = () => {
    console.log("[TestimonialsCarousel] Previous button clicked");
    try {
      if (sliderRef.current) {
        console.log("[TestimonialsCarousel] Calling slickPrev()");
        sliderRef.current.slickPrev();
        console.log("[TestimonialsCarousel] slickPrev() executed");
      } else {
        console.error("[TestimonialsCarousel] ERROR: sliderRef.current is null!");
      }
    } catch (error) {
      console.error("[TestimonialsCarousel] ERROR in handlePrevClick:", error);
    }
  };

  const handleNextClick = () => {
    console.log("[TestimonialsCarousel] Next button clicked");
    try {
      if (sliderRef.current) {
        console.log("[TestimonialsCarousel] Calling slickNext()");
        sliderRef.current.slickNext();
        console.log("[TestimonialsCarousel] slickNext() executed");
      } else {
        console.error("[TestimonialsCarousel] ERROR: sliderRef.current is null!");
      }
    } catch (error) {
      console.error("[TestimonialsCarousel] ERROR in handleNextClick:", error);
    }
  };

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    adaptiveHeight: false,
    lazyLoad: false,
    touchMove: true,
    swipeToSlide: false,
    beforeChange: (oldIndex, newIndex) => {
      console.log("[TestimonialsCarousel] Carousel changing from index", oldIndex, "to", newIndex);
    },
    afterChange: (currentIndex) => {
      console.log("[TestimonialsCarousel] Carousel changed to index", currentIndex);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <section className="bg-white sf-testimonials-section">
      <div className="sf-container">
        <div className="bg-gray mb-0">
          <h1 className="sf-testimonials-title">
            FEEDBACK FROM our valued customers.
          </h1>
          
          <div className="sf-testimonials-carousel-wrapper">
            <Slider ref={sliderRef} {...slickSettings}>
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="sf-testimonial-card-wrapper">
                  <div className="sf-testimonial-card">
                    <div className="sf-testimonial-avatar-wrap">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="sf-testimonial-avatar"
                      />
                    </div>
                    <h5 className="sf-testimonial-name">{testimonial.name}</h5>
                    <p className="sf-testimonial-designation">
                      {testimonial.designation}
                    </p>
                    <p className="sf-testimonial-text">{testimonial.feedback}</p>
                    <div className="sf-testimonial-rating">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <i key={i} className="fas fa-star"></i>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>

            {/* Custom Controls Below Carousel */}
            <div className="sf-testimonials-controls">
              <button
                onClick={handlePrevClick}
                className="sf-testimonial-arrow-btn sf-arrow-left"
                aria-label="Previous testimonials"
                type="button"
              >
                <i className="fas fa-arrow-left"></i>
              </button>
              <button
                onClick={handleNextClick}
                className="sf-testimonial-arrow-btn sf-arrow-right"
                aria-label="Next testimonials"
                type="button"
              >
                <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
